module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAAJ0lEQVRIx2NgmOSGB/3HC85pm+NBDKNGjxo9avSo0aNGjxo9FI0GAJs77BZqPSxuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/Content/Assets/images/flags/it.png
// module id = 1370
// module chunks = 0